// src/utils/pocketbase-safe.js
import { pb } from "@/utils/pocketbase";
import requests from "@/utils/requests";

export const safePb = {
    collection(name) {
        const raw = pb.collection(name);

        return {
            // 原生透传
            create(...args) {
                return raw.create(...args);
            },

            getOne(...args) {
                return raw.getOne(...args);
            },

            getList(...args) {
                return raw.getList(...args);
            },

            getFullList(...args) {
                return raw.getFullList(...args);
            },

            // 替换 update
            async update(id, data = {}) {
                const res = await requests.post("/api/pb/update", {
                    collection: name,
                    id,
                    data,
                });

                if (res.code !== 0) {
                    throw new Error(res.message || "Update failed");
                }

                return res.data;
            },

            // 替换 delete
            async delete(id) {
                const res = await requests.post("/api/pb/delete", {
                    collection: name,
                    id,
                });

                if (res.code !== 0) {
                    throw new Error(res.message || "Delete failed");
                }

                return res.data;
            },
        };
    },

    // 其他常用对象直接透传
    authStore: pb.authStore,
};